import * as packageActions from './Packages';
import * as screenActions from '../../Common/actions/Screen';
import {getLocalizedMoreInfoText, getLocalizedText, texts} from '../../../../constants/TextConst';
import {
    showConfirmMessage,
    showUnsavedChangesMessages,
    showInfoMessage
} from '../../../../_shared/Messages/actions/MessageActions';
import {messagesIds} from '../../../../_shared/Messages/consts';
import messagesText from '../../../../_shared/Messages/texts';
import * as screenTypes from '../../../../constants/ScreenTypes';
import * as treeScreenActions from '../derivatives/TreeDesign/actions/Screen';
import {packagesStore} from '../stores/Packages';

export let buildAndSendDs;
export let getPackageData;
let saveFlatDataFunc;
let restoreDefaults;
let runPackagesPanelServer;
let savePaintedDataFunc;
let refreshFormDesign;
let endDesigning;

export function initFunctions(funcs) {
    if (funcs) {
        screenActions.initFunctions(funcs);
        saveFlatDataFunc = funcs.saveFlatData;
        getPackageData = funcs.getPackageData;
        buildAndSendDs = funcs.buildAndSendDs;
        restoreDefaults = funcs.restoreDefaults;
        runPackagesPanelServer = funcs.runPackagesPanel;
        savePaintedDataFunc = funcs.savePaintedData;
        refreshFormDesign = funcs.refreshDesign;
        endDesigning = funcs.endDesigning;
        treeScreenActions.initFunctions(funcs);
        packageActions.initFunctions(funcs);
    }
}

export function insertFields(screen, data) {
    packagesStore.initPackages();
    screen.setCollection(data);
    if (!screen.fieldPacData) {
        getPackageData &&
            getPackageData(screen.name, (data, formPackData) => {
                screen.initPackagesData(data, formPackData);
                // if we changed packages in anotner screen => switch to Tree design while it's empty =>
                // we receive old data (without packages update) and need to update fields status on client side
                screen.name === screenTypes.design.TREE &&
                    screen.packagesChanged &&
                    treeScreenActions.updatePaintedData(screen);
                screen.setLoading(false);
            });
    } else {
        screen.setLoading(false);
    }
}

export function getData(screen) {
    screen.name === screenTypes.design.TREE
        ? treeScreenActions.getData(screen)
        : screenActions.getData(screen);
    screen.setPackagesChanged(false);
}

export function saveData(screensStore, closeCallback?) {
    const {selectedScreen} = screensStore;
    saveScreenData(screensStore, selectedScreen, null, closeCallback);
}

function _setPackagesChanged(screensStore, changedScreenName) {
    for (const key in screensStore.screens) {
        if (key !== changedScreenName) {
            screensStore.screens[key].setPackagesChanged(true);
        }
    }
}

function saveScreenData(screensStore, selectedScreen, endCallback?, closeCallback?) {
    const packsToUpdate = packageActions.getPacksToUpdate();
    selectedScreen.checkReloadNeeded(screensStore);
    if (packsToUpdate?.length > 0) {
        const reenterMsg = '\n' + getLocalizedText(texts.formReenter);
        _setPackagesChanged(screensStore, selectedScreen);
        selectedScreen.changed && selectedScreen.setChanged(false);
        const _endCallback = endCallback
            ? endCallback
            : screensStore.screens[screenTypes.design.TREE] &&
              screensStore.screens[screenTypes.design.TREE].packagesChanged &&
              refreshFormDesign;
        buildAndSendDs &&
            buildAndSendDs(
                packsToUpdate,
                () => {
                    closeCallback && endDesigning && endDesigning();
                    _saveData(selectedScreen, _endCallback);
                },
                msg =>
                    showInfoMessage({
                        id: messagesIds.screens.saveDataWarn,
                        title: `${msg}${screensStore.isReloadNeeded ? reenterMsg : ''}`,
                        onClose: () => {
                            closeCallback && closeCallback();
                        }
                    })
            );
    } else {
        closeCallback && endDesigning && endDesigning();
        if (selectedScreen.changed) {
            _saveData(selectedScreen, endCallback);
            selectedScreen.setChanged(false);
        }
        closeCallback && closeCallback();
    }
}

function _saveData(selectedScreen, endCallback) {
    if (selectedScreen.name === screenTypes.design.TREE) {
        savePaintedDataFunc &&
            savePaintedDataFunc(
                selectedScreen.name,
                selectedScreen.collection.fields,
                selectedScreen.picdesign,
                endCallback
            );
    } else {
        saveFlatDataFunc &&
            saveFlatDataFunc(
                selectedScreen.name,
                selectedScreen.isSplitted
                    ? selectedScreen.allFields
                    : selectedScreen.collection.fields,
                endCallback
            );
    }
}

export function selectScrollField(field) {
    selectField(field, true);
    screenActions.scrollField(field);
}

export function selectField(field, selectAny?) {
    const {screen} = field;
    initSelectedGroup(field);
    // processing click on unselected field
    if (!field.isSelected && (field.isSelectable || selectAny)) {
        screen.setSelected(field);
    }
    // if there's an 'active' field (with actions panel opened) and it's not the same as we're selecting now,
    // we should disactivate it to avoid clumsy situation when one field is selected and another is active

    if (screen.active && !field.isActive) {
        screen.setActive(null);
    }
}

export function isSelectEnabled(field) {
    return field.isSelectable;
}

function initSelectedGroup(field) {
    const {screen} = field;
    if (screen.selectedGroup.length > 0) {
        screen.selectedGroup.forEach(field => {
            field.setGrouped(false);
        });
        screen.selectedGroup = [];
    }
}

export function activateField(field) {
    const {screen} = field;
    packageActions.updatePackData(field);
    initSelectedGroup(screen);

    if (!field.isActive) {
        screen.setActive(field);
    } else {
        // processing click on active field
        screen.setActive(null);
    }
    // if there's an 'selected' field and it's not the same as we're activating now,
    // we should unselect it to avoid clumsy situation when one field is selected and another is active
    if (screen.selected && !field.isSelected) {
        screen.setSelected(null);
    }
}

export function addToSelectedGroup(field) {
    const {screen} = field;
    const {selectedGroup} = screen;
    if (field.grouped) {
        field.setGrouped(false);
        selectedGroup.splice(selectedGroup.indexOf(field), 1)[0];
        /* don't unselect the last field in the group */
        if (screen.selected.name === field.name && selectedGroup.length > 0) {
            //selectField(selectedGroup[0]);
            screen.setSelected(selectedGroup[0]);
        }
    } else if (!field.hidden && !field.isChanging) {
        if (screen.active) {
            screen.setActive(null);
        }
        if (!screen.selected) {
            selectField(field);
            field.setGrouped(true);
            selectedGroup.push(field);
        } else {
            if (selectedGroup.length === 0) {
                if (screen.selected.hidden) {
                    selectField(field);
                } else {
                    screen.selected.setGrouped(true);
                    selectedGroup.push(screen.selected);
                }
            }
            field.setGrouped(true);
            selectedGroup.push(field);
        }
    }
}

export function cancelChanged(screen) {
    screen.setChanged(false);
}

export function restoreDefaultValues(screensStore, confirmCallback) {
    const {selectedScreen} = screensStore;
    selectedScreen.setChanged(false);
    selectedScreen.checkReloadNeededOnRestore(screensStore);
    showConfirmMessage({
        id: messagesIds.screens.restoreDefaultsvalueConfirm,
        title: getLocalizedText(texts.restoreWarn),
        moreInfo: getLocalizedMoreInfoText(texts.restoreWarn),
        confirmButtonText: messagesText.noChangedMyMind,
        cancleButtonText: messagesText.yes,
        onCancel: () => {
            restoreDefaults && restoreDefaults(selectedScreen.name);
        },
        onConfirm: confirmCallback()
    });
}

export function changeScreen(screensStore, screenId) {
    if (screenId !== screensStore.selectedScreenKey) {
        if (screensStore.selectedScreen.changed) {
            showUnsavedChangesMessages(
                getLocalizedText(texts.saveChanges),
                () => {
                    saveAndChangeScreen(screensStore, screenId);
                },
                () => {
                    const prevScreen = screensStore.selectedScreen;
                    screensStore.setSelectedScreenKey(screenId);
                    screensStore.selectedScreen.setLoading(true);
                    packagesStore.resetPackages();
                    prevScreen.resetSelected();
                    _changeScreen(screensStore.selectedScreen);
                }
            );
        } else {
            screensStore.setSelectedScreenKey(screenId);
            screensStore.selectedScreen.setLoading(true);
            _changeScreen(screensStore.selectedScreen);
        }
    }
}

function saveAndChangeScreen(screensStore, screenId) {
    const prevScreen = screensStore.selectedScreen;
    screensStore.setSelectedScreenKey(screenId);
    prevScreen.resetSelected();
    screensStore.selectedScreen.setLoading(true);
    saveScreenData(screensStore, prevScreen, () => _changeScreen(screensStore.selectedScreen));
}

function _changeScreen(screen) {
    if (isGetDataNeeded(screen)) {
        getData && getData(screen);
    } else {
        screen.setLoading(false);
    }
}

function isGetDataNeeded(selectedScreen) {
    return (
        selectedScreen.collection.isEmpty ||
        selectedScreen.changed ||
        selectedScreen.packagesChanged
    );
}

export function isMovementsPanelShown(screen) {
    return screen.selected && screen.selected.isMovable;
}

export function runPackagesPanel(screensStore) {
    //screenActions.closePanel(screensStore);
    runPackagesPanelServer && runPackagesPanelServer();
}

export function cancelReloadNeeded(screensStore) {
    screensStore.isReloadNeeded = false;
}

export const designScreenActions = {
    changeScreen,
    initFunctions,
    insertFields,
    saveData
};
